import { FC, ReactElement, useRef } from 'react'
import { Channel as StreamChannel, StreamChat } from 'stream-chat'
import {
    Channel,
    Chat,
    MessageInput,
    MessageList,
    Window,
} from 'stream-chat-react'

import { ZeroState } from '@/components'
import { EditingMessageProvider } from '@/context/EditingMessageContext'
import { ScrollFollowProvider } from '@/context/ScrollFollowContext'
import { streamI18n } from '@/helpers/streamI18n'
import { trans } from '@/helpers/trans'
import { useAutoScrollToBottom } from '@/hooks/useAutoScrollToBottom'

import {
    ConversationHeader,
    ConversationListNotifications,
    ConversationMessage,
    ConversationMessageInput,
} from './subcomponents'

import './MessageDetailContainer.scss'

interface MessageDetailContainerProps {
    client: StreamChat
    channel?: StreamChannel
}

const HiddenAttachmentSelector: FC = () => null

export const MessageDetailContainer: FC<MessageDetailContainerProps> = ({
    channel,
    client,
}): ReactElement => {
    const containerRef = useRef<HTMLDivElement>(null)

    const scrollFollow = useAutoScrollToBottom(
        { containerRef, scrollSelector: '.str-chat__list', growthSelector: '.str-chat__ul' },
        channel?.cid,
    )

    return (
        <div className="message-detail" ref={containerRef}>
            {! channel ? (
                <ZeroState text={trans('pages.messages.conversationNotFound')} />
            ) : (
                <Chat client={client} i18nInstance={streamI18n} theme="str-chat__theme-light">
                    <Channel
                        AttachmentSelector={HiddenAttachmentSelector}
                        Message={ConversationMessage}
                        MessageListNotifications={ConversationListNotifications}
                        channel={channel}
                    >
                        <Window>
                            <EditingMessageProvider>
                                <ScrollFollowProvider value={scrollFollow}>
                                    <ConversationHeader />
                                    <MessageList
                                        disableQuotedMessages
                                        messageActions={['edit', 'delete']}
                                    />
                                    <MessageInput Input={ConversationMessageInput} />
                                </ScrollFollowProvider>
                            </EditingMessageProvider>
                        </Window>
                    </Channel>
                </Chat>
            )}
        </div>
    )
}
